<section role="region" class="wrapper--white">
  <header role="banner" class="training-obligation-hero">
    <div class="training-obligation-hero__text">
      <h1 role="heading" class="training-obligation-hero__title">
        <span class="line-break">Je suis sans formation, sans emploi et j&apos;ai entre 16 et 18 ans.</span>
        <span class="highlight--emphasis">Je me fais accompagner pour construire mon avenir.</span>
      </h1>
    </div>
    <div class="training-obligation-hero__background" *ngIf="(isMobileOrTabletPortrait$ | async) === false">
      <img src="/assets/images/hero/triangle-white.svg" alt="" class="training-obligation-hero__triangle-white" />
      <img
        [src]="heroIllustration | imaginarySrc: 1:1023"
        [srcset]="heroIllustration | imaginarySrc: 4:1023"
        class="training-obligation-hero__illustration"
        alt=""
        loading="lazy"
      />
    </div>
  </header>
</section>
